import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=1d709ca3&"
import script from "./trash.vue?vue&type=script&lang=js&"
export * from "./trash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d709ca3')) {
      api.createRecord('1d709ca3', component.options)
    } else {
      api.reload('1d709ca3', component.options)
    }
    module.hot.accept("./trash.vue?vue&type=template&id=1d709ca3&", function () {
      api.rerender('1d709ca3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/trash.vue"
export default component.exports